/**
 * İç içe açılan modallarda ESC / odak tuzağının yalnız en üstteki
 * modal tarafından işlenmesi için modül seviyesinde basit bir yığın.
 * `Modal` ve `ConfirmDialog` bu yığını paylaşır; böylece bir form
 * modalı üzerinde açılan ConfirmDialog'da ESC yalnız ConfirmDialog'u
 * kapatır, alttaki modal açık kalır.
 */
const openModalStack: symbol[] = [];

export function pushModal(id: symbol): void {
  openModalStack.push(id);
}

export function removeModal(id: symbol): void {
  const idx = openModalStack.indexOf(id);
  if (idx !== -1) openModalStack.splice(idx, 1);
}

export function isTopMostModal(id: symbol): boolean {
  return openModalStack[openModalStack.length - 1] === id;
}
